import { SourceDataPriority } from "@/api/dtos";
import SourceDataFormSettingsContext from "@/contexts/form/SourceDataFormSettingsContext";
import useItem from "@/hooks/form/source-data/useItem";
import { Tooltip, TooltipProps, styled } from "@mui/material";
import { FC, useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import SourceDataFormAuditButton from "./SourceDataFormAuditButton";
import SourceDataFormCombinedButton from "./SourceDataFormCombinedButton";
import SourceDataFormFindingButton from "./SourceDataFormFindingButton";
import SourceDataFormNoteButton from "./SourceDataFormNoteButton";
import SourceDataFormReviewAndVerificationButton from "./SourceDataFormReviewAndVerificationButton";


export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    marginTop: '12px !important'
}));


const SourceDataFormButtons: FC<{ 
    itemData?: ReturnType<typeof useItem>; 
    priority?: SourceDataPriority;
    allowReview?: boolean;
    allowVerification?: boolean;
    itemGroupAllowReview?: boolean;
    itemGroupAllowVerification?: boolean;
}> = ({
    itemData,
    priority,
    allowReview,
    allowVerification,
    itemGroupAllowReview,
    itemGroupAllowVerification
}) => {
    const { 
        settings: { 
            buttonLinkTarget,
            separateButtons,
            hideCombined,
            hideAudit,
            hideNotesAndQueries,
            hideFindings,
            hideReviews,
            hideVerifications
        } 
    } = useContext(SourceDataFormSettingsContext);

    const createButtonProps = useCallback((link: string) => {
        const buttonProps: any = {};

        switch (buttonLinkTarget) {
            case 'tab': 
                buttonProps.component = 'a';
                buttonProps.target = '_blank';
                buttonProps.href = `${link}?hide-layout=1`;
                break;
            case 'window':
    
                let windowWidth = 800;
                let windowHeight = 800;
    
                if (window.screen.availWidth < windowWidth) {
                    windowWidth = window.screen.availWidth;
                }
    
                if (window.screen.availHeight < windowHeight) {
                    windowHeight = window.screen.availHeight;
                }
    
                buttonProps.onClick = () => {
                    window.open(`${link}?hide-layout=1`, '_blank', `left=100,top=100,width=${windowWidth},height=${windowHeight}`)
                }
    
                break;
            case "current":
            default:
                buttonProps.component = Link;
                buttonProps.to = link
                break;
        }

        return buttonProps;
    }, [])

    return (
        <>
            {
                !hideAudit && separateButtons && (
                    <SourceDataFormAuditButton createButtonProps={createButtonProps} itemData={itemData} />
                )
            }
            {
                !hideNotesAndQueries && separateButtons && (
                    <SourceDataFormNoteButton createButtonProps={createButtonProps} itemData={itemData} />
                )
            }
            {
                !hideFindings && separateButtons && (
                    <SourceDataFormFindingButton createButtonProps={createButtonProps} itemData={itemData} />
                )
            }
            {
                !hideCombined && !separateButtons && (
                    <SourceDataFormCombinedButton createButtonProps={createButtonProps} itemData={itemData} />
                )
            }
            <SourceDataFormReviewAndVerificationButton 
                itemData={itemData} 
                priority={priority} 
                allowReview={allowReview}
                allowVerification={allowVerification}
                hideReview={hideReviews} 
                hideVerification={hideVerifications} 
                itemGroupAllowReview={itemGroupAllowReview}
                itemGroupAllowVerification={itemGroupAllowVerification}
            />
        </>
    )
};

export default SourceDataFormButtons;